import { itemCategories, specialAttributes } from '@/libs/constants/cart'

import { isValidArray } from './array'

export const sortCartItemsWithPairs = (cartItems, pairAttributes) => {
  const { currentMaterial, pairMaterial } = pairAttributes
  const pairItems = cartItems
    .filter((item) => !!item[currentMaterial])
    .reduce((pairs, originalItem) => {
      const res = cartItems.find(
        (item) => item?.materialNumber === originalItem[currentMaterial],
      )

      return [
        ...pairs,
        { ...originalItem },
        {
          ...res,
          [pairMaterial]: originalItem?.materialNumber,
        },
      ]
    }, [])

  return pairItems
}

export const mappedSpecialItems = (cartItems) => {
  if (!isValidArray(cartItems)) {
    return []
  }

  const cartItemsByObject = cartItems.reduce((accumulator, item) => {
    const key = `${item.materialNumber}|${item.itemCateg}`
    return { ...accumulator, [key]: item }
  }, {})

  for (const attribute of Object.keys(specialAttributes)) {
    for (const item of Object.values(cartItemsByObject)) {
      const { materialNumber } = item
      const pairedMaterialNumber = item[attribute]
      const pairedAttribute = specialAttributes[attribute]

      if (pairedMaterialNumber) {
        const itemCategoriesList = Array.isArray(itemCategories[attribute])
          ? itemCategories[attribute]
          : [itemCategories[attribute] ?? itemCategories.default]

        for (const category of itemCategoriesList) {
          const specialItemKey = `${pairedMaterialNumber}|${category}`

          if (cartItemsByObject[specialItemKey]) {
            cartItemsByObject[specialItemKey][pairedAttribute] = materialNumber
          }
        }
      }
    }
  }

  return Object.values(cartItemsByObject)
}
